import { render, staticRenderFns } from "./SystemBar.vue?vue&type=template&id=5ef8b6ca"
import script from "./SystemBar.vue?vue&type=script&lang=js"
export * from "./SystemBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports